import { useEffect, useState, useContext } from 'react';
import styles from './TestScreen2.module.css';
import TestContext from '../../store/testContextProvider';
import { useNavigate } from 'react-router-dom';
import audioIcon from '../../assets/Audio_Icon.png'
import { setFolderNames, getFolderNames, getFilenamesInWords } from '../../utils/FilenameList';
import { getFileCount, getAudio } from '../../utils/AudiofileHandling';
import Popup from '../Popup/Popup';

export default function TestScreen2(){
    const {testData} = useContext(TestContext);
    const navigate = useNavigate();
    const [showPopup, setShowPopup] = useState(false);    
    const [showRButtons, setShowRButtons] = useState(false);
    const [showOButtons, setShowOButtons] = useState(false);
    const [stage, setStage] = useState(0);
    const [instruction, setInstruction] = useState("");
    const [buttonDisplay, setButtonDisplay] = useState("Exit");

    const [difficulty, setDifficulty] = useState(false);
    const [folderPath, setfolderPath] = useState("");   
    const [fileCount, setFileCount] = useState(0);    
    const [fileNames, setFileNames] = useState([]);
    const [storyComplete, setStoryComplete] = useState(false)
    const [buttonDisable, setButtonDisable] = useState(true);
    const [cQ, setCQ] = useState(0);
    const [audioData, setAudioData] = useState(""); 
    

    const [score, setScore] = useState(0);
    const [totalStimulus, setTotalStimulus] = useState(0);
    const [repeatCount, setRepeatCount] = useState(0);

    
    useEffect(()=>{
        switch(stage){
            case 0:
                setInstruction("ಕೆಳಗಿನ ಹಂತವನ್ನು  ಆಯ್ಕೆ ಮಾಡಿ");          
                setShowRButtons(false);
                setShowOButtons(false);                
            break;
            case 1:
                setInstruction("ಕೆಳಗಿನ ಹಂತವನ್ನು  ಆಯ್ಕೆ ಮಾಡಿ");          
                setShowRButtons(false);
                setShowOButtons(false);                
            break;
            case 2:
                if(testData.title === "8.2 Stories")
                    setInstruction("ನಾನು ಹೇಳುವ ಕಥೆಯನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ನಂತರ ಅದಕ್ಕೆ ಸಂಬಂದಿಸಿದ ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಿಸಿ  ಮತ್ತು ಹಿನ್ನೆಲೆ ಶಬ್ದಕ್ಕೆ ಗಮನ ನೀಡದಿರಿ");          
                else
                    setInstruction("ನಾನು ಹೇಳುವ ಕಥೆಯನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ನಂತರ ಅದಕ್ಕೆ ಸಂಬಂದಿಸಿದ ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಿಸಿ");          
                setButtonDisplay("Questions");
                setButtonDisable(false);
                setShowRButtons(false);
                setShowOButtons(true);                
            break;
            case 3:
                if(testData.testCode===4.1)
                    setInstruction("ನಾನು ಹೇಳುವುದನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅದರಂತೆ ಅನುಸರಿಸಿ");          
                else                
                    setInstruction("ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಿಸಿ");          
                
                setShowRButtons(true);
                setShowOButtons(true);                
            break;
            default:
                console.log("error in Instruction switch statment");
        }
    }, [stage])

    //Get folder path
    useEffect(()=>{        
        if(difficulty)
            setfolderPath(pv=>getFolderNames(testData.folderNames));          

    },[difficulty]);

    //Get the max question and filenames, 
    useEffect(()=>{               
        if(folderPath!="")   
        {
            if(testData.testCode===4.1 || storyComplete) //Follow direction
            {
                console.log("A");
                async function getFCount(){                              //Get all the audio files
                    // console.log("folderPath", folderPath);
                    await getFileCount(folderPath, (fileCount)=>{
                        fileCount = fileCount-1;
                        setFileNames(pv=>getFilenamesInWords(1,fileCount, testData.isRandomise)); 
                        setFileCount(fileCount);              
                    })                
                }        
                getFCount();
            }else{  //Story                
                setFileNames(["story.wav"])
            }
        }
    }, [folderPath, storyComplete]);

    //Play audio one by one
    useEffect(()=>{
        if(fileNames.length>0)
        {            
            // console.log("playing");
            async function getAudiofile(){
                console.log("filepath", folderPath + "/" + fileNames[cQ])
                await getAudio(folderPath + "/" + fileNames[cQ], (data)=>{        
                    console.log(data)          
                    setAudioData(data);
                })
            }
            
            getAudiofile();
                 
        }
    }, [fileNames, cQ])

    useEffect(()=>{              
        play();
    }, [audioData]);

    function play(){        
        setTimeout(() => {
            if(audioData!="")
            {
                const audio = new Audio(audioData);               
                audio.play();  
                                
                //if story playing is complete
                if(testData.testCode!==4.1)
                {
                    // console.log("story complete")
                    const handleAudioPlayEnded = ()=>{
                        setButtonDisable(true);  //Question button
                    }
                    audio.addEventListener("ended", handleAudioPlayEnded);
                }
            }
        }, 500);        
    }

    function changeStage(){
        if(stage<2)
        {
            if (testData.testCode === 4.1) { 
                {
                    console.log("diff1", stage);           
                    setStage(2);
                }
            } 
            else{

                if(testData.testCode==4.2 && stage == 0)   //2.4 auditory Attendtion
                {
                    setStage(2);                        
                    setDifficulty(true); //Set this at the right stage to play the story. if this is done all done
                    console.log("diff2", stage);
                }
                else                                    //8.2 stories     
                {   
                    setStage(stage + 1);                
                    if(stage==1)
                        setDifficulty(true); //Set this at the right stage to play the story. if this is done all done
                    console.log("diff3", stage);
                }                                
            }        
        }            
        else
            setStage(0);        
        console.log("stage:", stage, "TestCode", testData.testCode)
    }
   
    function handleSNR(e){        
        e.preventDefault();
        const difficulty = e.target.id;
        const folderLength = testData.folderNames.length;
        setFolderNames(folderLength, e.target.id, testData.folderNames, testData.updateFolderNames)     
        console.log(testData.folderNames)        
        changeStage();
    }

    function handleExit(e){
        if(stage==2){
            // console.log("story complete")                        
            setButtonDisplay("Exit");
            setStoryComplete(true); 
            setRepeatCount(pv=>0)          
            setStage(3);
        }else{
            setShowPopup(!showPopup);
        }        
    }

    function handleRepeat(e){
        // play();
        setRepeatCount(pv=>pv+1);
    }

    function handleResponse(e){
        let response = 0;       
         setRepeatCount(pv=>0)
         response = (e.target.id === "correct")? 1: 0;
 
         //Save Response        
          setScore(pv=>pv+response);
          setTotalStimulus(pv=>pv+1);

        // console.log(cQ, fileCount-1);
          if(cQ<fileCount-1)
            setCQ(pv=>pv+1);  
          else
            setShowPopup(!showPopup);
    }
 

    const togglePopup = () => {
        setShowPopup(!showPopup);
        navigate('/homepage');
     };

     function content(){
        switch(stage){
            case 0:  
                if(testData.testCode==4.2)
                {
                    return(
                        <div className={styles.buttonList}>
                            <button id="story1" style={{backgroundColor: "#6F61C0"}} onClick={handleSNR}>Story1</button>
                            <button id="story2" style={{backgroundColor: "#6F61C0"}} onClick={handleSNR}>Story2</button>                        
                            <button id="story3" style={{backgroundColor: "#6F61C0"}} onClick={handleSNR}>Story3</button>
                            <button id="story4"style={{backgroundColor: "#6F61C0"}}onClick={handleSNR}>Story4</button>
                            {/* <button id="story5" style={{backgroundColor: "#6F61C0"}} onClick={handleSNR}>Story5</button> */}
                            {/* <button id="back" style={{backgroundColor: "#6F61C0", width: "50px", marginLeft:"35%"}} onClick={handleExit}>back</button> */}
                        </div>       
                    )
                }else
                {
                    return(
                        <div className={styles.buttonList}>
                            <button id="easiest" style={{backgroundColor: "#6F61C0"}} onClick={handleSNR}>Easiest</button>
                            <button id="easy" style={{backgroundColor: "#6F61C0"}} onClick={handleSNR}>Easy</button>                        
                            <button id="moderate" style={{backgroundColor: "#6F61C0"}} onClick={handleSNR}>Moderate</button>
                            <button id="hard"style={{backgroundColor: "#6F61C0"}}onClick={handleSNR}>Hard</button>
                            <button id="hardest" style={{backgroundColor: "#6F61C0"}} onClick={handleSNR}>Hardest</button>
                            {/* <button id="back" style={{backgroundColor: "#6F61C0", width: "50px", marginLeft:"35%"}} onClick={handleExit}>back</button> */}
                        </div>       
                    )
                }
                break;
            case 1:                
                return(
                    <div className={styles.buttonList}>
                        <button id="story1" style={{backgroundColor: "#6F61C0"}} onClick={handleSNR}>Story1</button>
                        <button id="story2" style={{backgroundColor: "#6F61C0"}} onClick={handleSNR}>Story2</button>                        
                        <button id="story3" style={{backgroundColor: "#6F61C0"}} onClick={handleSNR}>Story3</button>                      
                        {/* <button id="back" style={{backgroundColor: "#6F61C0", width: "50px", marginLeft:"35%"}} onClick={handleExit}>back</button> */}
                    </div>       
                )
                break;
            case 2:                       
                return(
                    <img src={audioIcon} alt='audio icon' />
                )
                break;
            case 3:                
                return (
                <div className={styles.question}>
                   <div>{cQ+1}/</div>
                   <div>{fileCount}.</div>
                   <img src={audioIcon} alt='audio icon' />
                </div>
                   
                )
                break;
        }
    }

    return(
        <div className={styles.container}>
            <div className={styles.instruction}>{instruction}</div>
            <div className={styles.content}>
                {
                    content()
                }                
            </div>
            <div className={styles.buttonList}>
                {
                    showRButtons?(                     
                        <div className={styles.responseButton}>
                            <button id="correct" className={styles.correct} onClick={handleResponse}>Correct</button>
                            <button id="wrong" className={styles.wrong} onClick={handleResponse}>Wrong</button>
                        </div>
                    ):(null)
                }
                {
                    showOButtons?(
                        <div className={styles.commonButtons}>
                            {                                
                                repeatCount<2?(<button id="repeat" style={{backgroundColor: "#6F61C0"}} className={styles.repeat} onClick={handleRepeat}>Repeat</button>):(null)
                            }
                            {
                                buttonDisable?(<button id="exit" style={{backgroundColor: "#6F61C0"}} className={styles.repeat} onClick={handleExit}>{buttonDisplay}</button>):(null)
                            }
                        </div>      
                    ):(null)
                }
            </div>            
            {showPopup && <Popup message={score + "/" + totalStimulus} onClose={togglePopup} />}
        </div>
    )
}